import { useAtomValue } from 'jotai';
import { selectedQuoteAtom } from '../../../store/global/atoms';

export const useSelectedQuoteValue = () => {
  const selectedQuote = useAtomValue(selectedQuoteAtom);

  return { selectedQuote };
};
